// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1Miq_","text":"SelectPayment_text__2dPnY","title":"SelectPayment_title__3BbDy","btn":"SelectPayment_btn__1lRwn"};